/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  export class ModalContextController {

    static $inject = ["context", "$mdDialog"]
    constructor(protected context: any, protected $mdDialog: angular.material.IDialogService) {
    }

    apply = (arr: any) => {
      this.$mdDialog.hide();
    }

    cancel = () => {
      this.$mdDialog.cancel();
    }
  }

  angular.module("meevo.components.controls")
    .controller("meevo.components.controls.ModalContextController", ModalContextController);
}